import { docodeHexResponse } from '../../_common/common.utils';
import GoldStockActionTypes from './gold-stock-report.types';

const INITIAL_STATE = {
	// GET GOLD STOCK REPORT RESPONSE
	getGoldStockReportResponse: null,
	getGoldStockReportArr: [],
};

const goldStockReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ********************* START GET GOLD STOCK REPORT DETAILS ******************** */
		case GoldStockActionTypes.GET_GOLD_STOCK_REPORT_SUCCESS:
			return {
				...state,
				getGoldStockReportResponse: action.payload,
				getGoldStockReportArr: docodeHexResponse(action.payload, 'GoldStockReportKey'),
			};

		case GoldStockActionTypes.GET_GOLD_STOCK_REPORT_FAILURE:
			return {
				...state,
				getGoldStockReportResponse: action.payload,
				getGoldStockReportArr: [],
			};

		case GoldStockActionTypes.GET_GOLD_STOCK_REPORT_RESPONSE_CHANGED:
			return {
				...state,
				getGoldStockReportResponse: null,
				getGoldStockReportArr: [],
			};
		/** ********************* END GET GOLD STOCK REPORT DETAILS ******************** */

		default:
			return state;
	}
};

export default goldStockReducer;
